export const verifyRoles = (roles) => {
  const userRoles = JSON.parse(localStorage.getItem('roles'));

  if (!userRoles || !roles) return false;

  let show = false;

  roles.forEach((pageRole) => {
    userRoles.forEach((userRole) => {
      if (userRole.role.toUpperCase() === pageRole.toUpperCase()) {
        show = true;
      }
    });
  });

  return show;
};
